module.exports = __webpack_public_path__ + "static/media/link.b43970e2.svg";